export const stepStyle = {
    backgroundColor: '#eaeaea',
} 
